import { useState, useEffect } from "react";
import { Newspaper } from "lucide-react";
import { API } from "../App";

// Daily Top News ticker — Yahoo headlines that scroll across the top; each opens in a new tab.
const NewsTicker = () => {
  const [headlines, setHeadlines] = useState([]);

  useEffect(() => {
    let active = true;
    const load = async () => {
      try {
        const [news, sports] = await Promise.all([
          fetch(`${API}/news/ticker?feed=news`).then((r) => r.json()).catch(() => ({})),
          fetch(`${API}/news/ticker?feed=sports`).then((r) => r.json()).catch(() => ({})),
        ]);
        const merged = [
          ...(news.headlines || []).map((h) => ({ ...h, kind: "news" })),
          ...(sports.headlines || []).map((h) => ({ ...h, kind: "sports" })),
        ];
        if (active) setHeadlines(merged);
      } catch (e) { /* ignore */ }
    };
    load();
    const i = setInterval(load, 30 * 60 * 1000); // refresh every 30 min
    return () => { active = false; clearInterval(i); };
  }, []);

  if (headlines.length === 0) return null;

  return (
    <div className="flex items-stretch bg-black text-white text-sm overflow-hidden border-b-2 border-yellow-500" data-testid="news-ticker">
      <div className="flex items-center gap-1 px-2 bg-red-700 font-bold flex-shrink-0 whitespace-nowrap">
        <Newspaper className="w-3.5 h-3.5" /> YAHOO NEWS &amp; SPORTS
      </div>
      <div className="flex-1 overflow-hidden relative">
        <div className="news-ticker-track flex items-center gap-8 whitespace-nowrap py-2 px-4">
          {[...headlines, ...headlines].map((h, i) => (
            <a
              key={i}
              href={h.link}
              target="_blank"
              rel="noopener noreferrer"
              className="text-white hover:text-yellow-300 hover:underline flex-shrink-0"
              data-testid={`news-headline-${i}`}
            >
              {h.kind === "sports" ? "🏈" : "📰"} {h.title}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NewsTicker;
